import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Image from 'react-bootstrap/Image'
import ExternalLink from '../../components/atoms/ExternalLink'
import text from '../../_constants/text'
import { associations } from '../../_constants/associations'

const ASSOCIATION_IMAGE_WIDTH = 200

const BillingGuideLookupAssociations: React.FC = () => {
  if (associations.length === 0) {
    return null
  }

  return (
    <Row className="no-gutters">
      <Col>
        <Card>
          <Card.Body className="pt-3 px-4 pb-0">
            <h2 className="mb-3 text-center">{text.OUR_ASSOCIATIONS}</h2>
            <Row className="d-flex align-items-center justify-content-center">
              {associations.map((association, index) => {
                const isSPACER = association.value.title === 'SPACER'

                // Render empty spacer column
                if (isSPACER) {
                  return (
                    <Col
                      key={index}
                      xs={12}
                      sm={6}
                      md={4}
                      lg={4}
                      className="d-flex justify-content-center align-items-center px-2"
                    >
                      {/* Empty spacer */}
                    </Col>
                  )
                }

                const imageStyle = {
                  width: 'auto',
                  height: 'auto',
                  maxHeight: '150px',
                  maxWidth: '180px',
                  display: 'block',
                  objectFit: 'contain' as const,
                  ...association.value.imageStyle,
                }

                const justifyClass = 'justify-content-center'

                return (
                  <Col
                    key={index}
                    xs={12}
                    sm={6}
                    md={4}
                    lg={4}
                    className={`d-flex ${justifyClass} align-items-center px-2`}
                  >
                    <ExternalLink href={association.value.link.value.url}>
                      <Image
                        data-testid="hyper-linked-image"
                        style={imageStyle}
                        src={association.value.image?.url}
                        alt={association.value.title}
                        width={ASSOCIATION_IMAGE_WIDTH}
                      />
                    </ExternalLink>
                  </Col>
                )
              })}
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default BillingGuideLookupAssociations
